import React from 'react';

import { FormContainerDropdown, FormLabel, FormLayoutFieldset } from '@/componentsAdmin/Parts/Form';
import { UserCondition } from '@/componentsAdmin/Parts/UserCondition/Forms';
import { DIRECT_FORM_OPTIONS } from '@/definitionDirect/FORM_OPTIONS';

/**
 * 検索条件フォーム 入力代行
 */
export const AdminSearchFormSectionInputAgency = (): React.ReactElement => {
  // ====================================================================================================
  //
  // JSX
  //
  // ====================================================================================================
  return (
    <UserCondition title="入力代行">
      <FormLayoutFieldset className="pl-24 w-200">
        <FormLabel label="入力代行ステータス" type="small"></FormLabel>
        <FormContainerDropdown
          name="input_agency"
          placeholder="選択してください"
          selectList={DIRECT_FORM_OPTIONS.inputAgencyStatus}
        ></FormContainerDropdown>
      </FormLayoutFieldset>
    </UserCondition>
  );
};
